import React, { useEffect, useState } from 'react';
import { VolumeSearch } from '../types';
import { useDebounce } from './useDebounce';
import { searchDocuments } from '../services/api';

export const QUERY_DEBOUNCE_DELAY = 700
function searchDomains({q, limit, offset, page, filter_by, sort_by}: {q:string, limit?:number, offset?:number, page?:number, filter_by?:string, sort_by?:string}){
  

    return {
      'q': q,
      limit: limit ? limit : 10,
      page : page? page:1,
      offset: offset?offset:0,
      num_typos: 0,
      filter_by: filter_by ? filter_by : '',
      sort_by: sort_by ? sort_by : '',
    }
  }
  


export default function useSearchDomains({ filterBy, query, limit, sort_by }: { filterBy: string; query: string, limit?:number, sort_by?:string }) {
  const [domains, setdomains] = useState<undefined | { document: VolumeSearch; highlight: Highlight }[]>(undefined);
  const [isLoaded, setIsLoaded] = useState(true);

  // Debounced Query
  const debouncedQuery = useDebounce(query, QUERY_DEBOUNCE_DELAY);
  useEffect(() => {
    (async () => {
      if (debouncedQuery) {
        setIsLoaded(false); // Indicate loading state
        const req = await fetch(searchDocuments('domains'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data: searchDomains({ q: debouncedQuery, filter_by: filterBy, limit, sort_by}),
          }),
        });

        const res: any = await req.json();
        setdomains(res.data?.hits);
        setIsLoaded(true); // Loading complete
      } else {
        setdomains([]);
      }
    })();
  }, [debouncedQuery, filterBy]);
 
  return {
    domains,
    isLoaded,
  };
}
